import { cx } from 'classix'
import {
	type CSSProperties,
	forwardRef,
	type ReactNode,
	useEffect,
	useRef,
	useState,
} from 'react'

import styles from './AnimatedHeight.module.css'

const DEFAULT_ANIMATION_DELAY = 300

export function AnimatedHeightRef(
	{
		children,

		'data-testid': dataTestId,
		className,
		delay = DEFAULT_ANIMATION_DELAY,
	}: Readonly<{
		children: ReactNode
		className?: string
		'data-testid'?: string
		delay?: number
	}>,
	ref: React.Ref<HTMLDivElement>
) {
	const [height, setHeight] = useState<CSSProperties['height']>('auto')
	const contentDiv = useRef<HTMLDivElement | null>(null)

	useEffect(() => {
		if (!contentDiv.current) {
			return () => {}
		}
		const element = contentDiv.current
		const resizeObserver = new ResizeObserver(() => {
			setTimeout(() => {
				setHeight(element.getBoundingClientRect().height)
			}, delay)
		})
		resizeObserver.observe(element)
		return () => {
			resizeObserver.disconnect()
		}
	}, [])

	return (
		<div
			ref={ref}
			data-testid={dataTestId}
			className={cx(styles.animated, className)}
			style={{ height }}
		>
			<div className={styles.content} ref={contentDiv}>
				{children}
			</div>
		</div>
	)
}

export const AnimatedHeight = forwardRef(AnimatedHeightRef)
